import { ColumnData } from "@gripp/shared-ui";
import { TagBatchesHome } from "./tagBatchesHome";
import { TagBatchesToolbar } from "./tagBatchesToolbar";
import { TagsHome } from "./tagsHome";
export enum TAGS_COLUMNS_ID {
  TAGS = 'tags',
  TAGS_BATCH = 'tagsBatch',
}

export const TagsColumns: ColumnData[] = [
  {
    id: TAGS_COLUMNS_ID.TAGS,
    title: 'tags.title',
    mainComponent: <TagsHome />
  }
];

export const TagBatchesColumns: ColumnData[] = [
  {
    id: TAGS_COLUMNS_ID.TAGS_BATCH,
    title: 'tags.batches.title',
    mainComponent: <TagBatchesHome />,
    headerComponent: <TagBatchesToolbar />,
  },
];